<template>
  <v-card>
    <v-img :src="require('@/assets/background.svg')">
      <v-card-text class="headline text-xs-center secondary--text">
        <template v-if="termoSelected">Termos de uso</template>
        <template v-else-if="politicaSelected">Política de Privacidade</template>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon absolute right v-on="on" @click="fechar()">
              <v-icon color="grey darken-2">close</v-icon>
            </v-btn>
          </template>
          Fechar Visualização
        </v-tooltip>
      </v-card-text>
      <template v-if="!loading">
        <v-card-text
          v-html="termoSelected.texto"
          v-if="termoSelected"
          class="scroll-y"
          style="max-height: 500px"
        ></v-card-text>
        <v-card-text
          v-html="politicaSelected.texto"
          v-if="politicaSelected"
          class="scroll-y"
          style="max-height: 500px"
        ></v-card-text>
      </template>
      <template v-else>
        <v-layout fill-height justify-center align-center>
          <v-progress-circular indeterminate size="250" color="primary"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>
  </v-card>
</template>

<script>
export default {
  data () {
    return {}
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    termoSelected () {
      return this.$store.getters.termoSelected
    },
    politicaSelected () {
      return this.$store.getters.politicaSelected
    }
  },
  methods: {
    fechar () {
      this.$store.dispatch('unselectTermoPolitica')
    }
  }
}
</script>
